import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import { Tooltip } from 'framework/ui/mui-builder';
import { Modal } from 'framework/ui/ui-builder';
import { Stack } from '@mui/material';
import { ModalForm, TextArea } from 'framework/form';
import React, { useState } from 'react';
import useClientPortalService from '../../useClientPortalService';
import { useParams } from 'react-router-dom';

type CancelTaskProps = {
  refetchClientPortalData: () => Promise<unknown>;
};

const CancelTask = ({ refetchClientPortalData }: CancelTaskProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { id, taskId } = useParams();
  const { getCancelTaskValidation, cancelClientPortalTask } = useClientPortalService();

  return (
    <>
      <Tooltip title="Cancel task">
        <IconButton>
          <CancelIcon color={'primary'} onClick={() => setIsModalOpen(true)} />
        </IconButton>
      </Tooltip>
      <Modal isOpen={isModalOpen} onToggle={() => setIsModalOpen(false)} title="Cancel task">
        <ModalForm
          modalOpen={isModalOpen}
          closeModal={() => setIsModalOpen(false)}
          submitFormFunc={data => cancelClientPortalTask(id!, taskId!, data)}
          getValidationSchemaFunc={getCancelTaskValidation}
          afterSubmit={{
            message: 'You are awesome! The Client Task has been cancelled.',
            execute: () => refetchClientPortalData(),
          }}
        >
          <Stack spacing={2} pb={4}>
            <TextArea source="reason" label="Please, provide the reason for cancelling this task" rows={3} />
          </Stack>
        </ModalForm>
      </Modal>
    </>
  );
};
export default CancelTask;
